export default "__VITE_ASSET__LS7Ypx0P__"